import type { RequiredGeneric } from '@pba/utils';
import { BellRingingLineIcon, Form, FormSection, Input } from 'ui';
import type { ExtendedDetailFormContentValues } from '../DetailFormContent';

export type ExtendedReminderDetailFormContentValues = {
  name: string;
};

const ReminderDetailFormContent = <T extends ExtendedReminderDetailFormContentValues = never>(
  _: RequiredGeneric<T>,
) => (
  <FormSection title={{ children: 'Reminder details', icon: <BellRingingLineIcon /> }}>
    <Form.Item<ExtendedDetailFormContentValues>
      label="Reminder name"
      name="name"
      rules={[{ required: true, whitespace: true }]}
    >
      <Input />
    </Form.Item>
  </FormSection>
);

export default ReminderDetailFormContent;
